import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "descriptionModal"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = ["innerHTML"]

import {default as templateStore} from "@/store";

import {defineComponent} from 'vue'
import {PassBonus} from "@/components/RegistrationPage/Card/PassProperties";
import store from "@/store";

const __default__ = defineComponent({
    name: 'BonusDescriptionModal',

    computed: {
        passBonus(): PassBonus
        {
            return store.state.passBonus as PassBonus
        },
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(templateStore).state.passBonus !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "background absolute-fill",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(templateStore).state.passBonus = null))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: "bi bi-x-lg",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(templateStore).state.passBonus = null))
          }),
          _createElementVNode("img", {
            alt: _ctx.passBonus.name,
            src: `/img/page/landing/registration/item/${_ctx.passBonus.image}.png`
          }, null, 8, _hoisted_3),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.passBonus.name), 1),
            _createElementVNode("div", {
              class: "description",
              innerHTML: _ctx.passBonus.description
            }, null, 8, _hoisted_5)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})